import Vue from 'vue';

import 'normalize.css/normalize.css'; // CSS resets
import 'font-awesome/css/font-awesome.min.css'; // font-awesome字体图标
/* 修改主题色*/
import '@/styles/theme/index.css';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/display.css';
import '@/styles/index.scss'; // global css
import '@/styles/el-col-4-8.css';
import '@/assets/iconfont/iconfont.css';

import App from './App';
import router from './router';
import store from './store';

import '@/permission'; // permission control
import permission from '@/directive/permission/index.js'; // 权限判断指令
import checkPermission from '@/utils/permission'; // 权限判断函数

import { formatDate, isStringEmpty } from '@/utils/index';
import datetimeUtil from '@/utils/gt/DateTimeUtil';
import { floor } from '@/utils/number';
import BaiduMap from 'vue-baidu-map'


Vue.use(BaiduMap, {
  /* 需要注册百度地图开发者来获取你的ak */
  ak: '3bVHdeo2ZZaZO4QczC63d0kMsbA55ZSD'
})
// Vue.use(Print);
Vue.use(ElementUI);
import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'　　　
import '../static/ueditor/ueditor.parse.min.js'

Vue.prototype.checkPermission = checkPermission;
Vue.directive('permission', permission);
/* Vue.prototype.window = window;*/

Vue.config.productionTip = false;
// 全局过滤器
Vue.filter('dateFilter', function(value) {
  // 日期yyyy-mm-dd格式化显示
  // return formatDate(value, true);
  if(!value){
    return '';
  }
  if(value instanceof Date){
    
  }
  else{
    value=new Date(value);
  }
  return datetimeUtil.toFormatString(value,'yyyy-MM-dd');
});
// 全局过滤器
Vue.filter('datetimeFilter', function(value) {
  // 日期yyyy-mm-dd格式化显示
  // return formatDate(value, true);
  if(!value){
    return '';
  }
  if(value instanceof Date){
    
  }
  else{
    value=new Date(value);
  }
  return datetimeUtil.toFormatString(value,'yyyy-MM-dd HH:mm:ss');
});
Vue.filter('numFloor', function(value) {
  // 显示保留两位小数
  return floor(value);
});
Vue.filter('moneyFilter', function(value) {
  if(value==null||value==undefined){
    return '';
  }
  return `￥${value.toFixed(2)}`;
});

Vue.filter('pointFilter', function(value) {
  if(value==null||value==undefined){
    return '';
  }
  return `${value}积分`;
});
Vue.filter('nothing', function(value) {
  // 详情无内容显示-过滤器
  if (isStringEmpty(value)) {
    return '无';
  } else {
    return value;
  }
});

Vue.filter('addressFilter', (row)=>{
  if(!row){
    return '';
  }
    let str='';
    str+=(row.province&&row.province.name)||'';
    str+=(row.city&&row.city.name)||'';
    str+=(row.area&&row.area.name)||'';
    str+=(row.street&&row.street.name)||'';
    str+=row.address||'';
    return str;
});


UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
UE.Editor.prototype.getActionUrl = function(action) {
    // console.log('xxxxxxxxxxxxxxxxx main.js');
    if (action == 'uploadimage' || action == 'uploadscrawl' || action == 'uploadimage') {
        return window.baseapi+'/api/file/UeUpload';
    } else if (action == 'uploadvideo') {
        return window.baseapi+'/api/file/UeUpload';//http://a.b.com/video.php';
    } else {
        return this._bkGetActionUrl.call(this, action);
    }
}
// console.log('UE',UE);

Vue.prototype.$refresh=function() {
  this.$store.dispatch("tagsView/delView", this.$route);
  this.$router.replace({path:'/refresh'});
}
// console.log('xxxxxxxxxxx',Vue.prototype.$back);
Vue.prototype.$back=function() {
  this.$store.dispatch("tagsView/delView", this.$route);
  this.$router.back();
}

// console.log('xxxxxxxxxxx',Vue.prototype.$replace);
Vue.prototype.$replace=function(data) {
  this.$store.dispatch("tagsView/delView", this.$route);
  this.$router.replace(data);
}
Vue.prototype.$setNavTitle=function(name) {
  this.$route.query.__tit=name||'';
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js